import Firebase from "firebase";

var FIREBASE_URI = "https://firestoneandparson.firebaseio.com/";

export default new Firebase(FIREBASE_URI);

